import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const CodeBlock = ({ code, language }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Function to add syntax highlighting classes (simplified version)
  const highlightCode = (code, language) => {
    // This is a simplified version - in a real app you would use a library like Prism.js or highlight.js
    if (language === "json") {
      return code
        .replace(/"([^"]+)":/g, '<span class="text-info">"$1"</span>:')
        .replace(/: "([^"]+)"/g, ': <span class="text-success">"$1"</span>')
        .replace(/: (\d+)/g, ': <span class="text-warning">$1</span>')
        .replace(/: (true|false)/g, ': <span class="text-error">$1</span>')
        .replace(/\[|\]|\{|\}/g, '<span class="text-primary">$&</span>');
    } else if (language === "javascript" || language === "js") {
      return code
        .replace(/(const|let|var|function|return|if|else|for|while)/g, '<span class="text-primary">$1</span>')
        .replace(/(\/\/.*)/g, '<span class="text-text-tertiary">$1</span>')
        .replace(/"([^"]+)"/g, '<span class="text-success">"$1"</span>')
        .replace(/'([^']+)'/g, '<span class="text-success">\'$1\'</span>');
    } else if (language === "python") {
      return code
        .replace(/(def|import|from|as|if|else|for|while|return|class)/g, '<span class="text-primary">$1</span>')
        .replace(/(#.*)/g, '<span class="text-text-tertiary">$1</span>')
        .replace(/"([^"]+)"/g, '<span class="text-success">"$1"</span>')
        .replace(/'([^']+)'/g, '<span class="text-success">\'$1\'</span>');
    } else if (language === "bash" || language === "shell") {
      return code
        .replace(/(#.*)/g, '<span class="text-text-tertiary">$1</span>')
        .replace(/(-[a-zA-Z])/g, '<span class="text-warning">$1</span>')
        .replace(/"([^"]+)"/g, '<span class="text-success">"$1"</span>');
    }
    return code;
 };

  return (
    <div className="relative rounded-md overflow-hidden">
      <div className="absolute right-2 top-2 z-10">
        <button
          onClick={handleCopy}
          className="p-1.5 bg-white bg-opacity-90 hover:bg-opacity-100 rounded-md border border-border shadow-sm text-text-secondary hover:text-primary transition-colors"
          aria-label={copied ? "Copied!" : "Copy code"}
        >
          <Icon name={copied ? "Check" : "Copy"} size={16} />
        </button> 
      </div>
      <div className="flex items-center bg-[#A89B8D] px-4 py-2">
        <span className="text-xs font-medium text-white uppercase">{language}</span> 
      </div>
      <pre className="bg-[#A89B8D] p-4 overflow-x-auto text-sm text-white">
        <code dangerouslySetInnerHTML={{ __html: highlightCode(code, language) }} />
      </pre>
    </div>
  );
};

export default CodeBlock;